var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBreastPain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "111px",
    height: "103px",
    viewBox: "0 0 111 103",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2E536821-75F3-49D4-ABAA-D60E33E01CC3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.167068 0.262568831 10.8816818 0.262568831 10.8816818 21 0.167068 21"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.159767907 0.262568831 10.8744174 0.262568831 10.8744174 21 0.159767907 21"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.-side-effects",
    transform: "translate(-667.000000, -646.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(670.000000, 649.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6e-05,87.81342 C0.40266,62.42592 2.21196,38.38692 5.59986,27.65232 C11.33196,9.49122 29.93556,17.17992 37.86066,7.40232 C39.36246,5.54922 40.18746,3.16302 40.77726,0.00012",
    id: "Stroke-1",
    stroke: "#222456",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.73485,87.81342 C105.33225,62.42592 103.52295,38.38692 100.13505,27.65232 C94.40265,9.49122 75.79905,17.17992 67.87395,7.40232 C66.37215,5.54922 65.54745,3.16302 64.95765,0.00012",
    id: "Stroke-3",
    stroke: "#222456",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.23288,61.13307 C19.12308,69.22467 17.02368,77.99967 15.48288,87.81357",
    id: "Stroke-5",
    stroke: "#222456",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.62332,61.99878 C86.73312,70.09038 88.71132,77.99958 90.25182,87.81348",
    id: "Stroke-7",
    stroke: "#222456",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8593,64.84203 C20.9586,70.81413 20.7498,74.10363 23.1771,90.23523",
    id: "Stroke-9",
    stroke: "#222456",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.55793,90.23511 C84.98493,74.10381 85.12023,70.92081 85.21953,64.94871",
    id: "Stroke-11",
    stroke: "#222456",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.84259,36.75366 C23.90529,37.82406 23.65929,38.87046 23.24199,39.96246 C22.82439,41.05506 22.23549,42.19296 21.61209,43.44696 C20.98869,44.70066 20.33079,46.07016 19.77609,47.62506 C19.22109,49.18026 18.76899,50.92116 18.55689,52.91706 C18.25719,55.73856 18.46719,58.34256 19.09749,60.66096 C19.72749,62.97996 20.77779,65.01306 22.15929,66.69396 C23.54049,68.37426 25.25259,69.70236 27.20589,70.61016 C29.15949,71.51796 31.35429,72.00576 33.70119,72.00576 C35.10639,72.00576 36.53139,71.86986 37.96479,71.55876 C39.39819,71.24766 40.83999,70.76166 42.27879,70.06146 C43.71759,69.36156 45.15339,68.44746 46.57479,67.28046",
    id: "Stroke-13",
    stroke: "#222456",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.11214,56.84517 C36.11214,57.31647 36.01644,57.76557 35.84364,58.17447 C35.67084,58.58307 35.42094,58.95087 35.11194,59.25987 C34.80294,59.56887 34.43484,59.81877 34.02624,59.99157 C33.61794,60.16437 33.16854,60.26007 32.69724,60.26007 C32.22564,60.26007 31.77654,60.16437 31.36794,59.99157 C30.95934,59.81877 30.59124,59.56887 30.28224,59.25987 C29.97354,58.95087 29.72334,58.58307 29.55054,58.17447 C29.37774,57.76557 29.28204,57.31647 29.28204,56.84517 C29.28204,56.37357 29.37774,55.92447 29.55054,55.51587 C29.72334,55.10727 29.97354,54.73917 30.28224,54.43017 C30.59124,54.12147 30.95934,53.87127 31.36794,53.69847 C31.77654,53.52597 32.22564,53.42997 32.69724,53.42997 C33.16854,53.42997 33.61794,53.52597 34.02624,53.69847 C34.43484,53.87127 34.80294,54.12147 35.11194,54.43017 C35.42094,54.73917 35.67084,55.10727 35.84364,55.51587 C36.01644,55.92447 36.11214,56.37357 36.11214,56.84517 Z",
    id: "Stroke-15",
    stroke: "#222456",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.29954,36.75366 C82.23684,37.82406 82.48284,38.87046 82.90014,39.96246 C83.31774,41.05506 83.90664,42.19296 84.53004,43.44696 C85.15344,44.70066 85.81134,46.07016 86.36604,47.62506 C86.92104,49.18026 87.37314,50.92116 87.58494,52.91706 C87.88494,55.73856 87.67494,58.34256 87.04464,60.66096 C86.41464,62.97996 85.36434,65.01306 83.98284,66.69396 C82.60164,68.37426 80.88954,69.70236 78.93624,70.61016 C76.98264,71.51796 74.78784,72.00576 72.44094,72.00576 C71.03574,72.00576 69.61074,71.86986 68.17734,71.55876 C66.74394,71.24766 65.30214,70.76166 63.86334,70.06146 C62.42454,69.36156 60.98874,68.44746 59.56704,67.28046",
    id: "Stroke-17",
    stroke: "#222456",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.02999,56.84517 C70.02999,57.31647 70.12539,57.76557 70.29849,58.17447 C70.47129,58.58307 70.72119,58.95087 71.03019,59.25987 C71.33919,59.56887 71.70699,59.81877 72.11589,59.99157 C72.52419,60.16437 72.97359,60.26007 73.44489,60.26007 C73.91649,60.26007 74.36559,60.16437 74.77419,59.99157 C75.18279,59.81877 75.55059,59.56887 75.85989,59.25987 C76.16859,58.95087 76.41879,58.58307 76.59159,58.17447 C76.76439,57.76557 76.86009,57.31647 76.86009,56.84517 C76.86009,56.37357 76.76439,55.92447 76.59159,55.51587 C76.41879,55.10727 76.16859,54.73917 75.85989,54.43017 C75.55059,54.12147 75.18279,53.87127 74.77419,53.69847 C74.36559,53.52597 73.91649,53.42997 73.44489,53.42997 C72.97359,53.42997 72.52419,53.52597 72.11589,53.69847 C71.70699,53.87127 71.33919,54.12147 71.03019,54.43017 C70.72119,54.73917 70.47129,55.10727 70.29849,55.51587 C70.12539,55.92447 70.02999,56.37357 70.02999,56.84517 Z",
    id: "Stroke-19",
    stroke: "#222456",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(23.100000, 77.455500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04259,20.95959 L0.76149,18.97629 C0.38469,18.85719 0.13929,18.49449 0.16959,18.10059 L1.00899,7.11879 C1.05009,6.57999 1.57629,6.21579 2.09499,6.36699 L3.69939,6.83529 C4.12179,6.95859 4.56849,6.73929 4.72929,6.32919 L6.89679,0.80259 C7.20399,0.01929 8.34069,0.11019 8.51949,0.93219 L10.86159,11.70009 C10.99929,12.33339 10.40619,12.88179 9.78579,12.69519 L8.16969,12.20889 C7.57119,12.02859 6.98949,12.53439 7.08429,13.15239 L8.13909,20.01939 C8.23479,20.64249 7.64349,21.14949 7.04259,20.95959",
    id: "Fill-21",
    fill: "#ED7330",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.4905,82.66011 L2.6559,77.30421 C2.4261,76.98321 2.4474,76.54581 2.7081,76.24881 L9.9693,67.96761 C10.3254,67.56171 10.9653,67.58601 11.2893,68.01801 L12.2916,69.35541 C12.5556,69.70731 13.0446,69.80001 13.419,69.56871 L18.4695,66.44811 C19.1853,66.00591 20.04,66.76071 19.6899,67.52571 L15.102,77.54481 C14.832,78.13401 14.0286,78.21681 13.644,77.69511 L12.6432,76.33671 C12.2724,75.83331 11.5035,75.88881 11.2089,76.43991 L7.9317,82.56651 C7.6344,83.12181 6.8574,83.17251 6.4905,82.66011",
    id: "Fill-24",
    fill: "#ED7330"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(72.000000, 77.455500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99894,20.95959 L10.28004,18.97629 C10.65684,18.85719 10.90194,18.49449 10.87194,18.10059 L10.03254,7.11879 C9.99144,6.57999 9.46494,6.21579 8.94654,6.36699 L7.34214,6.83529 C6.91974,6.95859 6.47304,6.73929 6.31224,6.32919 L4.14474,0.80259 C3.83724,0.01929 2.70084,0.11019 2.52204,0.93219 L0.17994,11.70009 C0.04194,12.33339 0.63504,12.88179 1.25574,12.69519 L2.87154,12.20889 C3.47034,12.02859 4.05204,12.53439 3.95724,13.15239 L2.90244,20.01939 C2.80644,20.64249 3.39804,21.14949 3.99894,20.95959",
    id: "Fill-26",
    fill: "#ED7330",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.65106,82.66011 L103.48536,77.30421 C103.71546,76.98321 103.69386,76.54581 103.43346,76.24881 L96.17196,67.96761 C95.81586,67.56171 95.17626,67.58601 94.85226,68.01801 L93.84996,69.35541 C93.58596,69.70731 93.09666,69.80001 92.72226,69.56871 L87.67176,66.44811 C86.95626,66.00591 86.10126,66.76071 86.45166,67.52571 L91.03956,77.54481 C91.30926,78.13401 92.11296,78.21681 92.49726,77.69511 L93.49806,76.33671 C93.86916,75.83331 94.63806,75.88881 94.93266,76.43991 L98.20986,82.56651 C98.50716,83.12181 99.28416,83.17251 99.65106,82.66011",
    id: "Fill-29",
    fill: "#ED7330"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreastPain);
export default __webpack_public_path__ + "static/media/breastPain.81aee379.svg";
export { ForwardRef as ReactComponent };